<div id="content">
  <!--Begin NavBar CFN-->
  <section>
    <div class="container-md">
      <div class="row mb-5" style="margin-top:70px;">
        <div class="col-12 text-center col-md-12 col-lg-12 mt-4">
          <div class="text-center icon-box" style="background: rgba(255,255,255,0.7);">
            <div class="icon"></div>
          </div>
          <h5 class="text-dark cfnDashboardTitle01 mt-5 mb-0" data-aos="fade-up" data-aos-delay="600"
            data-aos-once="true" style="margin: 22px; font-size:1.8rem"><strong>Vos bulletins de paie distribués en
              moins de 5 minutes.</strong><br></h5>
          <p class="lead text-dark d-none d-md-inline-block" data-aos="fade" data-aos-delay="850" data-aos-once="true"
            style="margin: 15px;font-weight: 400;">Conservez durablement vos documents, dans le respect du cadre légal
            et des normes en vigueur.<br></p>
        </div>
        <div class="col-12 text-center col-md-5 col-lg-5 mt-4 mb-lg-0">
          <div class="text-center icon-box" style="background: rgba(255,255,255,0.7);">
            <div class="icon"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="container-fluid">
    <!--Heading presentation CFN-->
    <!--3 Services CFN-->
    <section id="services-1" class="services">
      <div class="container-md section-title">
        <div class="row">
          <div class="col-12 text-center col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
            <div class="text-center icon-box" data-aos="fade-up" data-aos-once="true"
              style="background: rgba(255,255,255,0.85);">
              <div class="icon">
                <i class="fas fa-file-alt fa-fw"></i>
                <h4 class="title text-dark">Consultez vos bulletins de paie en toute sécurité</h4>
                <p class="description">Vos fiches de paie sont stockées et sécurisées dans le coffre-fort numérique
                  Décisiel.<br></p>
              </div>
            </div>
          </div>
          <div class="col-12 text-center col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
            <div class="text-center icon-box" data-aos="fade-up" data-aos-delay="250" data-aos-once="true"
              style="background: rgba(255,255,255,0.85);">
              <div class="icon">
                <i class="fas fa-cloud-download-alt fa-fw"></i>
                <h4 class="title text-dark">Téléchargez vos bulletins de paie</h4>
                <p class="description">Vous pouvez télécharger en masse (format zip) vos bulletins de paie.</p>
              </div>
            </div>
          </div>
          <div class="col-12 text-center col-md-6 col-lg-4 d-flex align-items-stretch mb-5 mb-lg-0">
            <div class="text-center icon-box" data-aos="fade-up" data-aos-delay="500" data-aos-once="true"
              style="background: rgba(255,255,255,0.85);">
              <div class="icon">
                <img src="assets/v2/img/CFN-LOGO-Sign-only.svg" style="width: 48px;margin-bottom: 15px;">
                <h4 class="title text-dark">Votre compte CFN</h4>
                <p class="description">Vous pouvez activer/désactiver votre compte de coffre-fort à tout moment.<br></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Services CFN cliquables-->
    <section id="services2" class="services2 mb-5">
      <div class="container-md">
        <div class="col-12" style="padding: 20px;margin-bottom: 20px;margin-top: 20px;">
          <h4 class="text-dark mb-0 text-dark" data-aos="fade-up"
            style="margin: 22px;text-shadow: 1px 1px 6px rgba(255,255,255,0.95);text-align: center;">
            <strong>SERVICES</strong><br></h4>
          <p class="lead text-dark d-none d-sm-none d-md-none d-lg-inline-block mt-3" data-aos="fade-up"
            data-aos-delay="250" style="font-weight: 400;">Le coffre-fort numérique distribue vos fiches de paie au
            format électronique de manière sécurisée et économique.<br></p>
        </div>
        <div class="row">
          <div class="col-md-6 col-xl-4 mb-4">
            <a href="#" [routerLink]="'/FichesPaie'">
              <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                <div class="card-body">
                  <div class="row align-items-center no-gutters">
                    <div class="col">
                      <div class="text-dark font-weight-bold h6 mb-0"><span class="title">Mes fiches de paie</span>
                      </div>
                      <div class="mb-0 text-xs"><span class="description"></span></div>
                    </div>
                    <div class="col-auto icon"><i class="far fa-file-alt fa-2x"></i></div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-xl-4 mb-4">
            <a href="#" [routerLink]="'/HistoriqueActivation'">
              <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                <div class="card-body">
                  <div class="row align-items-center no-gutters">
                    <div class="col">
                      <div class="text-dark font-weight-bold h6 text-sm-left mb-0"><span class="title">Historiques
                          d'activation</span></div>
                      <div class="mb-0 text-xs"><span class="description"></span></div>
                    </div>
                    <div class="col-auto icon"><i class="fas fa-history fa-2x"></i></div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-xl-4 mb-4" *ngIf="isResponsable()">
            <a href="#" [routerLink]="'/BulletinsSalaire'">
              <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                <div class="card-body">
                  <div class="row align-items-center no-gutters">
                    <div class="col">
                      <div class="text-dark font-weight-bold h6 mb-0"><span class="title">Approbation</span></div>
                      <div class="mb-0 text-xs"></div>
                    </div>
                    <div class="col-auto icon"><i class="fas fa-tasks fa-2x"></i></div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-xl-4 mx-auto mb-4">
            <a href="#" [routerLink]="'/help'">
              <div class="card shadow border-bottom-yellow1 py-3" data-aos="fade-up">
                <div class="card-body">
                  <div class="row align-items-center no-gutters">
                    <div class="col">
                      <div class="text-dark font-weight-bold h6 mb-0"><span class="title">Manuel d'utilisation</span>
                      </div>
                      <div class="mb-0 text-xs"></div>
                    </div>
                    <div class="col-auto icon"><i class="fas fa-info-circle fa-2x"></i></div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!--Begin Footer Decisiel-->
  </div>
</div>
